import {
  ORGANIZATION_TYPE,
  type OrganizationType,
} from 'lib.store/src/main/organization/organizationType';

export const home = '/';
export const leads = '/leads';
export const lead_qualifications = '/lead-qualifications';
// the company brief lives on the organization settings page — the matching
// empty state points there
export const attendee_company_profile = '/settings/company';
export const attendee_matches = '/matching';
export const campaigns = '/campaigns';
export const campaigns_create = '/campaigns/create';
export const campaigns_create_new = '/campaigns/create/new';
export const campaigns_ads = '/campaigns/ads';
export const campaigns_group = '/campaigns/group';
export const campaigns_edit = '/campaigns/edit';

//EVENTS
export const dashboard = '/dashboard';
export const audiences = '/audiences';
export const audiences_create = '/audiences/create';
export const audiences_edit = '/audiences/edit';
export const audiences_segment_create = '/audiences/segment/create';
export const audiences_segment_edit = '/audiences/segment/edit';
export const moderation = '/moderation';
export const analytics = '/analytics';
export const events_setup = '/events/setup';
export const ad_accounts = '/ad_accounts';

//PARTNER
export const media_plan = '/media-plan';
// the Creatives desk's own media plan: the forecast band and the creatives table
export const media_plan_creatives = '/media-plan-creatives';
export const creatives = '/creatives';
// the Ideas gallery as its own page — above Creatives in the menu
export const ideas = '/ideas';
export const brief = '/brief';
export const events_catalog = '/events/catalog';
export const events_catalog_with_tour = '/events/catalog?is-tour=true';
export const events_edit = '/events/edit';
export const events_create = 'events/create';
export const events_lp_create = '/landing/create';
export const landings = '/landing-pages';
export const pro = '/pro';
export const constructor = '/constructor';
export const settings = '/settings';
export const first_session_flow = '/first-session-flow';

//COMMON
export const events = '/events';
export const eventsWithTour = '/events?is-tour=true';
export const partners = '/partners';
export const help = '/help';

export const billing = '/billing';
export const profile = '/profile';
export const notifications = '/notifications';

export const login = '/login';
export const logout = '/logout';
export const registration = '/registration';
export const registration_event = '/registration/event';
export const registration_attendee = '/registration/attendee';

//ATTENDEE
export const attendee_shortlist = '/shortlist';
export const attendee_chats = '/chats';
// one company, wherever it opens from: its page on the left, its chat on the right
export const attendee_companies = '/companies';
export const attendee_meetings = '/meetings';
// what every match is picked from: the attendee brief and the concierge's notes
export const attendee_memory = '/memory';

//ADMIN
export const admin_users = '/admin/users';

//LANDING
export const landingPartner = 'https://boost.express/';
export const landingEvent = 'https://event.boost.express/';

/**
 * Where an account lands after sign-in or registration, per organization type.
 *
 * This is the one place the two products differ on entry: **Match.Express**
 * (attendee) opens on the matching deck — matching IS the product there and
 * "My events" is a secondary view reachable by URL — while **Boost.Express**
 * (partner, organizer) opens on My events. The platform admin opens on the
 * users table, and an account with no type yet has nowhere to be but sign-in.
 *
 * Auth screens navigate to `home` instead of naming a page, and each role's
 * route table resolves `/` and anything unmatched through here, so a landing
 * page moves in exactly one edit.
 */
export const HOME_ROUTE_BY_ORGANIZATION_TYPE: Record<OrganizationType, string> = {
  [ORGANIZATION_TYPE.attendee]: attendee_matches,
  [ORGANIZATION_TYPE.partner]: events,
  [ORGANIZATION_TYPE.organizer]: events,
  [ORGANIZATION_TYPE.admin]: admin_users,
  [ORGANIZATION_TYPE.none]: login,
};

/**
 * The landing route for an organization type; sign-in for an absent or
 * unknown one, which is where an account without a type belongs anyway.
 *
 * @param type organization type as the API sends it
 */
export const homeRouteFor = (type?: OrganizationType | null): string =>
  (type && HOME_ROUTE_BY_ORGANIZATION_TYPE[type]) || login;
